import httpManager from "@/app/shared/utils/httpManager";

export async function fetchUsersData(name) {
  const response = await httpManager.get(`/users/?search=${name}`);

  return response?.data;
}
